import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {
  EXPORT_PRESET_DAYS,
  ExportDateRange,
  MAX_EXPORT_RANGE_DAYS,
  checkCustomRange,
  countDays,
  getPresetRange,
  toDateString,
} from './export-date-range';

/**
 * Asks which orders to export: the last 30 / 60 / 90 days, or a custom range of at most 90 days.
 * Closes with an ExportDateRange; dismissing it (Cancel, X, Esc) exports nothing.
 */
@Component({
  selector: 'app-export-csv-dialog',
  templateUrl: './export-csv-dialog.component.html',
  styleUrls: ['./export-csv-dialog.component.scss'],
})
export class ExportCsvDialogComponent {
  readonly maxRangeDays = MAX_EXPORT_RANGE_DAYS;
  readonly presets = EXPORT_PRESET_DAYS;
  readonly today = toDateString(new Date());

  selected: number | 'custom' = EXPORT_PRESET_DAYS[0];
  customStart = '';
  customEnd = '';

  constructor(public activeModal: NgbActiveModal) {}

  /** The range that will be exported, or null while the choice is incomplete or invalid. */
  get range(): ExportDateRange | null {
    if (this.selected === 'custom') {
      return checkCustomRange(this.customStart, this.customEnd, this.today)
        .range;
    }
    return getPresetRange(this.selected);
  }

  get error(): string | null {
    if (this.selected !== 'custom') {
      return null;
    }
    return checkCustomRange(this.customStart, this.customEnd, this.today).error;
  }

  get dayCount(): number | null {
    const range = this.range;
    return range ? countDays(range.start_date, range.end_date) : null;
  }

  download(): void {
    const range = this.range;
    if (range) {
      this.activeModal.close(range);
    }
  }
}
